<template>
  <Modal :title="approveText" :value="value" @input="$emit('input', $event)">
    <Form ref="form" :model="form" :rules="rules">
      <FormItem prop="remarks">
        <Input
          type="textarea"
          :placeholder="$t('message.placeholder', [$t('form.approvalIdea')])"
          v-model="form.remarks"
          :autosize="{ minRows: 3, maxRows: 5 }"
        ></Input>
      </FormItem>
    </Form>
    <template slot="footer">
      <Button type="text" @click="cancel">{{ $t('btn.cancel') }}</Button>
      <debounce-btn type="primary" @click="ok">{{ approveText }}</debounce-btn>
    </template>
  </Modal>
</template>
<script>
  import DebounceBtn from '@/components/debounceBtn.vue';
  export default {
    name: 'ApproveModal',
    components: {
      DebounceBtn,
    },
    props: {
      value: {
        type: Boolean,
        default: false,
      },
      func: {
        type: Function,
        default: () => {},
      },
      approveState: {
        type: Number,
        default: 0, // 0: 通过 1: 驳回
      },
    },
    data() {
      return {
        form: {
          remarks: this.approveState == 0 ? this.$i18n.t('btn.yes') : '',
        },
        rules: {
          remarks: [
            {
              required: true,
              message: this.$i18n.t('message.notNull', [this.$i18n.t('form.approvalIdea')]),
              trigger: 'change',
            },
            {
              validator: (rule, value, callback) => {
                const MAX_LENGTH = 200;
                if (value.length <= MAX_LENGTH) {
                  callback();
                } else {
                  callback(new Error(this.$i18n.t('message.notOver', [this.$i18n.t('form.approvalIdea'), MAX_LENGTH])));
                }
              },
              trigger: 'blur',
            },
          ],
        },
      };
    },
    methods: {
      // 批量审批
      async ok(resetLoading) {
        const valid = await this.$refs.form.validate();
        if (valid) {
          const resp = await this.func(this.form.remarks);
          if (resp.code == process.env.VUE_APP_code) {
            this.$Message.success(resp.message);
            resetLoading();
            this.modal = false;
            this.$emit('input', false);
            this.$emit('ok');
          } else {
            this.$Message.error(resp.message);
            resetLoading();
          }
        } else {
          resetLoading();
        }
      },
      // 取消
      cancel() {
        this.$emit('input', false);
      },
    },
    watch: {
      // 监听审批状态
      approveState(val) {
        this.$refs.form.resetFields();
        this.form.remarks = val == 0 ? this.$i18n.t('btn.yes') : '';
      },
    },
    computed: {
      // 批量同意 or 批量拒绝
      approveText() {
        return this.approveState == 0 ? this.$i18n.t('key18') : this.$i18n.t('key19');
      },
    },
  };
</script>
<style lang="less" scoped></style>
